export default __webpack_public_path__ + "static/media/image1.dac9c59d.jpg";